import { render, staticRenderFns } from "./Fire.vue?vue&type=template&id=5b7f63a2&scoped=true&"
import script from "./Fire.vue?vue&type=script&lang=js&"
export * from "./Fire.vue?vue&type=script&lang=js&"
import style0 from "./Fire.vue?vue&type=style&index=0&id=5b7f63a2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7f63a2",
  null
  
)

export default component.exports